import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  ErrorHandler,
  inject,
  mergeApplicationConfig,
  provideAppInitializer
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { provideNgProgressRouter } from 'ngx-progressbar/router';

import { isCrawler } from '@core/helpers';
import { provideRlottieOptions } from '@core/rlottie';
import { provideWebsocketClientOptions } from '@core/websocket';
import { environment } from '@env';

import { appConfig } from './app.config';
import { AuthHttpInterceptor } from './modules/users';

let websocketConnectionUrl: string | null = null;

if (typeof localStorage !== 'undefined') {
  websocketConnectionUrl = localStorage.getItem('wsUrl');
}

if (!websocketConnectionUrl) {
  const websocketProtocol = window.location.protocol.replace('http', 'ws');

  websocketConnectionUrl = `${websocketProtocol}//${window.location.host}${environment.websocketPath}`;
}

export const config = mergeApplicationConfig(appConfig, {
  providers: [
    provideServiceWorker('./ngsw-worker.js', {
      enabled: environment.production && !isCrawler,
      registrationStrategy: 'registerImmediately'
    }),
    provideWebsocketClientOptions({
      url: websocketConnectionUrl,
      reconnectInterval: 2000
    }),
    provideRlottieOptions(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
        logErrors: !environment.production
      })
    },
    {
      provide: TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    provideNgProgressRouter({
      startEvents: [NavigationStart],
      completeEvents: [
        NavigationEnd,
        NavigationCancel,
        NavigationError
      ]
    })
  ]
});
